/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { default as React } from "react";
import { IExternalUser } from "../../types/ExternalUserTypes";

const Body = styled.div`
  margin-left: 60px;
  display: flex;
  flex-direction: column;
`;

const TableContainer = styled.div`
  /* display: flex; */
  height: fit-content;
  justify-content: center;
  font-size: 15px;
  overflow-y: auto;
`;

interface Props {
  externalUser: IExternalUser;
}

export default function ExternalUsersDetails(props: Props): JSX.Element {
  const { externalUser } = props;

  return (
    <Body>
      <TableContainer>
        {externalUser.forms.length > 0 ? (
          externalUser.forms.map((form) => <p>{form.name}</p>)
        ) : (
          <p style={{ fontStyle: "italic" }}>No forms attached yet...</p>
        )}
      </TableContainer>
    </Body>
  );
}
